import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { convertTimeStampToDate } from "./../../../utilities/commonFunctions/timeConversionFunctions";
import { GET_OPEN_COMPLIANCE_SCHEDULES } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import { openComplianceScheduleType } from "./../../../utilities/constants/OpenComplianceScheduleConstants";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const OpenComplianceScheduleTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "Type",
      accessor: (d) => {
        return d.scheduleTypeCode ? openComplianceScheduleType[d.scheduleTypeCode] : "";
      },
      width: 200
    },
    {
      Header: "Required Activites",
      accessor: "activityName"
    },
    {
      Header: "Severity",
      accessor: "severity",
      width: 50
    },
    {
      Header: "Created",
      accessor: (d) => {
        return d.createdDate ? convertTimeStampToDate(d.createdDate) : "";
      },
      width: 50
    },
    {
      Header: "Due",
      accessor: (d) => {
        return d.dueDate ? convertTimeStampToDate(d.dueDate) : "";
      },
      width: 50
    }
  ];

  const { loading, error, data } = useQuery(GET_OPEN_COMPLIANCE_SCHEDULES, { variables: { systemId } });

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getOpenComplianceSchedules.length > 0 ? (
        <DtsReactTable data={data.getOpenComplianceSchedules} columns={columns} headerColor='ddw' />
      ) : (
        <span>No Open Compliance Schedules were found in the database.</span>
      )}
    </>
  );
};

export default OpenComplianceScheduleTable;
